import React, { useState, useEffect, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "./CipHeader";
// Adjust this relative path to match where the service lives in your project.
import videoService from "../services/videoService";

const HelpVideos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadVideos = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await videoService.getVideos();
      setVideos(Array.isArray(data) ? data : []);
    } catch (e) {
      setError("Could not load videos. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadVideos();
  }, [loadVideos]);

  return (
    <div>
      <CipHeader />
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10">
            <span className="text-xl">HELP & GUIDE</span>
          </div>
        </div>
        <div className="px-6 py-5">
          <p className="mt-4 inline-block font-base mb-4">
            <span className="text-gray-500">Note : </span>
            Watch these short videos to learn how to use the application.
          </p>

          {/* Loading state */}
          {loading && (
            <div className="p-2 text-xs w-full grid grid-cols-4 gap-y-2 gap-x-1">
              {Array.from({ length: 4 }).map((_, i) => (
                <div
                  key={i}
                  className="flex flex-col rounded-2xl p-3 m-2 bg-white shadow-md"
                >
                  <div
                    className="relative w-full overflow-hidden rounded-xl bg-gray-200 animate-pulse"
                    style={{ paddingBottom: "56.25%", height: 0 }}
                  />
                  <div className="mt-2">
                    <div className="h-3 w-3/4 bg-gray-200 rounded animate-pulse" />
                    <div className="h-2 w-full bg-gray-100 rounded animate-pulse mt-2" />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Error state */}
          {!loading && error && (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <p className="text-sm text-red-500 mb-3">{error}</p>
              <button
                type="button"
                onClick={loadVideos}
                className="px-4 py-2 text-sm rounded bg-header_bg text-white hover:opacity-90"
              >
                Retry
              </button>
            </div>
          )}

          {/* Empty state */}
          {!loading && !error && videos.length === 0 && (
            <div className="flex items-center justify-center py-12">
              <p className="text-sm text-gray-500">No videos available right now.</p>
            </div>
          )}

          {/* Video grid — each card is a link that opens the player in a new tab */}
          {!loading && !error && videos.length > 0 && (
            <div className="p-2 text-xs w-full grid grid-cols-4 gap-y-2 gap-x-1">
              {videos.map((video, i) => (
                <a
                  key={video.name || i}
                  href={video.playerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Play video: ${video.title} (opens in a new tab)`}
                  className="flex flex-col rounded-2xl p-3 m-2 cursor-pointer bg-white shadow-md hover:shadow-lg no-underline"
                >
                  <div
                    className="relative w-full overflow-hidden rounded-xl bg-gray-100"
                    style={{ paddingBottom: "56.25%", height: 0 }}
                  >
                    <img
                      src={video.thumbnailUrl}
                      alt={video.title}
                      className="absolute top-0 left-0 w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.style.visibility = "hidden";
                      }}
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div
                        className="w-8 h-8 rounded-full flex items-center justify-center"
                        style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
                      >
                        <span
                          className="text-white text-xs"
                          style={{ marginLeft: "2px" }}
                        >
                          &#9654;
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <span className="text-sm font-semibold text-gray-800 block">
                      {video.title}
                    </span>
                    <span className="text-xs text-gray-500 block mt-0.5">
                      {video.description}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(HelpVideos)
);